export const styles = {
    root: {
        
    },
    container: {
        display: "flex",
        flexDirection: "column",
        paddingLeft: "50px",
        borderBottom: "1px solid #EDEBE9",
    },
    elem: {
        padding: "12px 8px 12px 8px"
    },
    elemtext: {
        fontFamily: "Segoe UI",
        fontSize: "16px",
        fontWeight: 400,
        lineHeight: "20px",
        color: "#323130",
        marginRight:"5px"
    },
    subelemtext: {
        fontFamily: "Segoe UI",
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: "20px",
        color: "#323130",
        marginRight:"5px"
    },
    topsection: {
        display: "flex",
        flexdirection: "row",
        alignContent: "center",
        minHeight: "30px",
        marginBottom: "2px",
        justifyContent: "space-between"
    },
    bottomsection: {
        display: "flex",
        flexdirection: "row",
        alignContent: "center",
        alignItems: "baseline",
        minHeight: "18px"
    },
    tooltipHostSection: {
        root: {
            display: "contents"
        }
    }
};

